const SITE      = 'Structurecity';
const SITE_URL  = (process.env.VUE_APP_FRONTEND_URL || 'https://www.structurecity.com').replace(/\/$/, '');
const DEFAULT_DESC  = "Africa's premier construction and real estate platform. Browse verified listings, connect with professionals, and grow your business across Africa.";
const DEFAULT_IMAGE = SITE_URL + '/assets/og-image.png';

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content || '');
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * @param {object} opts
 * @param {string}  [opts.title]       — Page title (site name appended automatically)
 * @param {string}  [opts.description] — Meta description (HTML stripped, truncated to 160)
 * @param {string}  [opts.image]       — Absolute URL for OG/Twitter image
 * @param {string}  [opts.url]         — Canonical URL (defaults to current href)
 * @param {string}  [opts.type]        — OG type: 'website' | 'article' (default 'website')
 * @param {boolean} [opts.noindex]     — Add noindex,nofollow (e.g. search results, 404)
 */
export function useSEO({ title, description, image, url, type = 'website', noindex = false } = {}) {
  const fullTitle = title ? `${title} | ${SITE}` : SITE;
  const rawDesc   = (description || DEFAULT_DESC).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  const desc      = rawDesc.length > 160 ? rawDesc.slice(0, 157) + '…' : rawDesc;
  const img       = image || DEFAULT_IMAGE;
  const href      = url || window.location.href;

  document.title = fullTitle;

  setMeta('name',     'description',          desc);
  setMeta('name',     'robots',               noindex ? 'noindex,nofollow' : 'index,follow');

  setMeta('property', 'og:title',             fullTitle);
  setMeta('property', 'og:description',       desc);
  setMeta('property', 'og:image',             img);
  setMeta('property', 'og:url',               href);
  setMeta('property', 'og:type',              type);
  setMeta('property', 'og:site_name',         SITE);

  setMeta('name',     'twitter:card',         'summary_large_image');
  setMeta('name',     'twitter:title',        fullTitle);
  setMeta('name',     'twitter:description',  desc);
  setMeta('name',     'twitter:image',        img);

  setCanonical(href);
}

export const SITE_ORIGIN = SITE_URL;

/**
 * Inject or replace a single JSON-LD script block (marked with data-sc).
 * Pass null/undefined to remove any existing block.
 */
export function setJsonLd(schema) {
  const existing = document.querySelector('script[type="application/ld+json"][data-sc]');
  if (!schema) { if (existing) existing.remove(); return; }
  const el = existing || document.createElement('script');
  el.type = 'application/ld+json';
  el.setAttribute('data-sc', '1');
  el.textContent = JSON.stringify(schema);
  if (!existing) document.head.appendChild(el);
}
